import React from "react";
import PropTypes from "prop-types";
import Heading from "atoms/Heading";
import Text from "atoms/Text";
import Image from "next/image";
import { useSelector } from "react-redux";
import Card from "atoms/Card";

const MultiCompanySelect = ({ onClick }) => {
  const companyList = useSelector((state) => state?.companyUsers?.companies); //reading company list from redux store
  const myLoader = ({ src }) => src;
  return (
    <div className="md:min-h-screen flex items-center justify-center px-6 py-14 relative z-10">
      <Card
        cardClass="p-6 shadow-lg opacity-100 rounded-[39.29px] flex flex-col items-center relative z-20"
        cardBg="bg-oneConnectBg"
        cardWidth="w-[360px]"
        cardHeight="h-[500px]"
        cardBorder="border-0"
      >
        <Heading
          type="h2"
          className="text-brandGreen flex items-center justify-center gap-2 mb-4"
        >
          <img
            src="/images/1CLogo.svg"
            alt="1C Logo"
            className="h-14 w-auto mix-blend-multiply"
          />
          <span className="font-black">1 Connect</span>
        </Heading>
        <Heading
          type="h4"
          className="mb-2 font-schibsted text-oneConnectBlue text-center"
          style={{ color: "#014078" }}
        >
          Select Company
        </Heading>
        <Text
          className="mb-4 font-poppins text-oneConnectBlue text-center text-sm"
          style={{ color: "#014078" }}
        >
          Select the company you would be working on
        </Text>
        <div className="w-full flex-1 overflow-y-auto pr-2 space-y-4">
          {companyList?.length > 0 ? (
            companyList?.map((company) => (
              <div
                className="flex items-center p-4 rounded-[20px] border-2 border-gray-300 cursor-pointer hover:border-brandGreen hover:bg-white transition-all bg-white shadow-sm flex-shrink-0"
                key={company?.id}
                id={company?.id}
                onClick={() => onClick?.(company)}
              >
                <div className="flex items-center shrink-0 mr-4">
                  <Image
                    id="img_tag_147"
                    src={company?.logo}
                    loader={myLoader}
                    width={109}
                    height={52}
                    alt={company?.companyName}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <Heading
                    type="h5"
                    className="font-schibsted font-semibold text-base break-words"
                    style={{ color: "#014078" }}
                  >
                    {company?.companyName}
                  </Heading>
                </div>
              </div>
            ))
          ) : (
            <Text
              className="text-oneConnectBlue text-center"
              style={{ color: "#014078" }}
            >
              No companies available
            </Text>
          )}
        </div>
      </Card>
    </div>
  );
};

MultiCompanySelect.propTypes = {
  companyLists: PropTypes.array,
  onClick: PropTypes.func,
};

export default MultiCompanySelect;
